export default {
  DISABLED: 'DISABLED',
  ADHOC: 'ADHOC',
  AUTO: 'AUTO',
}
